import styled from 'styled-components';
import { H1smallDesktop, nonResponsiveParagraph } from '../../../../theme/typography';
import { Button } from '../../../../shared/components/button';

export const Container = styled.div``;

export const Title = styled(H1smallDesktop)`
  margin-bottom: 32px;
`;

export const Description = styled.span`
  display: block;
  ${nonResponsiveParagraph};
  margin-bottom: 40px;
`;

export const AccountButton = styled(Button)``;
